import { Icon, IconNames, Tooltip } from '@dixa/lib-shared-habla';
import { cloneElement, ReactElement, type ReactNode } from 'react';

import styles from './contactCardLine.module.scss';

type ContactCardLineProps = {
  icon: IconNames;
  label: string;
  content: ReactElement | string;
  contentTooltip?: string;
  actions?: ReactNode;
};

export const ContactCardLine = (props: ContactCardLineProps): JSX.Element => {
  const { icon, label, content, contentTooltip, actions } = props;

  return (
    <div className={styles.item}>
      <div className={styles.content}>
        <Tooltip
          content={label}
          wrap="div"
          wrapProps={{ style: { display: 'flex' } }}
        >
          <Icon name={icon} size={16} aria-label={label} />
        </Tooltip>

        <Tooltip
          content={contentTooltip}
          disabled={!contentTooltip}
          wrap="none"
        >
          {typeof content === 'string' ? (
            <span className={styles.info}>{content}</span>
          ) : (
            cloneElement(content, { className: styles.info })
          )}
        </Tooltip>
      </div>

      <div className={styles.actions}>{actions}</div>
    </div>
  );
};
